import http from '@/utils/http'

export function getRequestsFromApplications(params){
    return http(`/requests_from_applications`,{params})
}
export function addRequestsFromApplications(id,data){
    return http.post(`/applications/${id}/need_correct`,data)
}
export function batchDeleteApplicationForms(data){
    return http.post(`/batch_delete_application_forms`,data)
}
export function batchSendAnnouncementEmails(data){
    return http.post(`/batch_send_announcement_emails`,data)
}
export function addBatchChangeApplicationFormsStatus(data){
    return http.post(`/batch_change_application_forms_status`,data)
}
export function addBatchChangeApplicationFormsStage(data){
    return http.post(`/batch_change_application_forms_stage`,data)
}
export function confirmRequest(id,data){
    return http.post(`/applications/${id}/confirm_request`,data)
}
export function solvedRequest(id){
    return http.post(`/requests_from_applications/${id}/solved_request`)
}
export function getApplicationDetail(id){
    return http(`/application_forms/${id}`)
}
export function putApplicationDetail(id,data){
    return http.put(`/application_forms/${id}`,data)
}
export function getApplication(params){
    return http('/application_forms',{params})
}
export function exportRequest(id){
    return http.post(`/applications/${id}/export_request`)
}
export function batchExportApplicationsRequest(data){
    return http.post(`/batch_export_applications_request`,data)
}

export function getInterviews(params){
    return http('/interviews',{params})
}
export function getApplicationFormReports(params){
    return http('/application_form_reports',{params})
}
export function uploadReceiptRequests(id,data){
    return http.post(`/application_forms/${id}/upload_receipt_requests`,data)
}

export function exportAttachments(data){
    return http.post(`/export_attachments`,data)
}
export function importInterviews(data){
    return http.post(`/import_interviews`,data)
}
export function batchDeleteInterviews(data){
    return http.post(`/batch_delete_interviews`,data)
}

